import http from '../common/http-auth'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllRoles = async () => {
    const response = http.get(`/role/getallroles`)
    return response;
}